import { IServiceRequest, ServiceRequestStatus } from "../models"
import { useEffect, useState } from "react"

import { FieldFilterType } from "../../../../base/types"
import { useAuth } from "../../../../../modules/auth"
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi"

export const useGetServiceRequestGatePassId = (serviceRequest?: IServiceRequest) => {
    const { user, siteId } = useAuth()
    const [getRecords] = useLazyReadMultipleQuery()
    const [gatePassId, setGatePassId] = useState<string>()
    const [gpOut, setGPOut] = useState<boolean>()
    const [gpIn, setGPIn] = useState<boolean>()

    useEffect(() => {
        if (!serviceRequest ||
            (serviceRequest?.statusCode !== ServiceRequestStatus.Approved &&
                serviceRequest?.statusCode !== ServiceRequestStatus.AutoApproved &&
                serviceRequest?.statusCode !== ServiceRequestStatus.ActiveCancelled &&
                serviceRequest?.statusCode !== ServiceRequestStatus.Rejected &&
                serviceRequest?.statusCode !== ServiceRequestStatus.Closed))
            return;

        getGatePassId(serviceRequest.id)
        // eslint-disable-next-line
    }, [serviceRequest])

    const getGatePassId = (requestId: string): Promise<string> => {
        if (!user?.contactId) {
            return Promise.reject('User contact not found.')
        }

        return getRecords({
            userId: user?.userId || '',
            portalId: siteId || '',
            tableId: "gp_gatepass",
            fieldList: ["gp_gatepassid","gp_out","gp_in"],
            filters: [{
                group: 0, filters: [
                    { field: "edtec365_servicerequest", type: FieldFilterType.Const, value: requestId },
                    { field: "gp_studentname", type: FieldFilterType.Const, value: user?.contactId },
                    { field: "statuscode", type: FieldFilterType.Filter, value: `365970001|365970003|2|365970000|365970005|365970007` },]
            }]
        })
            .unwrap()
            .then((data) => {
                if (data.records.length > 0) {
                    const gatePassId = data.records[0]["gp_gatepassid"] as string
                    const markedOut = data.records[0]["gp_out"] as boolean
                    const markedIn = data.records[0]["gp_in"] as boolean
                    setGatePassId(gatePassId)
                    setGPOut(markedOut)
                    setGPIn(markedIn)
                    return Promise.resolve(gatePassId)
                }

                return Promise.reject('No active gate pass found.');
            })
    }

    return { gatePassId, gpOut,gpIn }
}